module.exports = __webpack_public_path__ + "4127a6cbd2591cc12097eae18157c167.svg";